import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";

// Import React FilePond
import { FilePond, File, registerPlugin } from "react-filepond";

// Import FilePond styles

// Import the Image EXIF Orientation and Image Preview plugins
// Note: These need to be installed separately
// `npm i filepond-plugin-image-preview filepond-plugin-image-exif-orientation --save`
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import "filepond/dist/filepond.min.css";
import { Col, Row } from "reactstrap";

// Register the plugins
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImagePreview);

const CreateFolder = () => {
  const [show, setShow] = useState(false);
  const [files, setFiles] = useState([]);
  const [checkedCountries, setCheckedCountries] = useState({});
  const brands = ["Danube Home Online", "Milano", "Danube Properties"];
  const countries = ["All Countries", "UAE", "Oman", "Bahrain", "Qatar"];

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    console.log(data);
    handleClose();
  };

  const handleCountryChange = (brand, country) => {
    setCheckedCountries((prevState) => {
      const brandState = prevState[brand] || {};
      const isChecked = !brandState[country];

      const newBrandState = { ...brandState, [country]: isChecked };

      // If "All Countries" is checked, check all other countries
      if (country === "All Countries") {
        countries.forEach((c) => {
          newBrandState[c] = isChecked;
        });
      } else {
        // If any country is unchecked, uncheck "All Countries"
        if (!isChecked) {
          newBrandState["All Countries"] = false;
        }
        // If all countries (except "All Countries") are checked, check "All Countries"
        else if (countries.slice(1).every((c) => newBrandState[c])) {
          newBrandState["All Countries"] = true;
        }
      }

      return { ...prevState, [brand]: newBrandState };
    });
  };

  return (
    <>
      <span className="addFolder" onClick={handleShow}>
        <i className="bx bx-folder-plus"></i>
      </span>

      <Modal size="xl" show={show} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton className="border-bottom pb-3">
          <Modal.Title>Create Wallet/Promotion/Gift Card/Brands</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(onSubmit)} className="fs-14">
            <Row>
              <Col md={12}>
                <div className="form-group mb-3">
                  <label className="fs-14">Name</label>
                  <input
                    type="text"
                    className={`form-control ${
                      errors.name ? "is-invalid" : ""
                    }`}
                    {...register("name", { required: true })}
                  />
                  {errors.name && (
                    <div className="invalid-feedback">
                      Reward Name is required
                    </div>
                  )}
                </div>
              </Col>
              <Col md={6}>
                <div className="form-group mb-5">
                  <label className="fs-14">Logo Image</label>
                  <FilePond
                    files={files}
                    onupdatefiles={setFiles}
                    allowMultiple={true}
                    maxFiles={3}
                    server="/api"
                    name="files"
                    labelIdle='Drag & Drop your files or <span class="filepond--label-action">Browse</span>'
                  />
                </div>
              </Col>
              <Col md={6}>
                <div className="form-group mb-5">
                  <label className="fs-14">Icon Image</label>
                  <FilePond
                    files={files}
                    onupdatefiles={setFiles}
                    allowMultiple={true}
                    maxFiles={3}
                    server="/api"
                    name="files"
                    className="fs-14"
                    labelIdle='Drag & Drop your files or <span class="filepond--label-action">Browse</span>'
                  />
                </div>
              </Col>
              {brands.map((brand, index) => (
                <Col md={12} key={index}>
                  <div className="d-flex gap-2 align-items-center justify-content-start mb-4">
                    <h6 className="mb-0 mt-2 fs-14" style={{ width: 175 }}>
                      {brand}
                    </h6>
                    <div
                      className="form-group d-flex flex-wrap gap-2"
                      style={{ width: "calc(100% - 175px)" }}
                    >
                      {countries.map((country, idx) => (
                        <div
                          className="px-3 py-2 border rounded-5 d-flex align-items-center justify-content-center"
                          key={idx}
                        >
                          <div className="form-check mb-0">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`${brand}-${country}`}
                              checked={
                                checkedCountries[brand]?.[country] || false
                              }
                              onChange={() =>
                                handleCountryChange(brand, country)
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`${brand}-${country}`}
                            >
                              {country}
                            </label>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </Col>
              ))}
              <Col md={12}>
                <div className="form-group mb-3 mt-3">
                  <label className="fs-14">Description</label>
                  <textarea
                    className={`form-control ${
                      errors.description ? "is-invalid" : ""
                    }`}
                    {...register("description", { required: true })}
                  ></textarea>
                  {errors.description && (
                    <div className="invalid-feedback">
                      Description is required
                    </div>
                  )}
                </div>
              </Col>
            </Row>
            <div className="my-3 d-flex gap-2 justify-content-end">
              <Button variant="outline-dark" onClick={handleClose}>
                Close
              </Button>
              <Button variant="info" type="submit">
                Save Changes
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CreateFolder;
